import { Injectable } from '@angular/core';
import { AngularFirestore, DocumentReference } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Temporada } from '../../temporadas/models/temporada';
import { Equipo } from '../models/equipo';
import { EquipoViewModel } from '../models/equipo-view-model';

@Injectable({
    providedIn: 'root'
})
export class EquipoService {

    constructor(private db: AngularFirestore) { }

    private temporadaCollectionName = 'temporadas';
    private equipoCollectionName = 'equipos';

    getEquipos(temporadaId: string): Observable<firebase.default.firestore.QuerySnapshot> {
        return this.db.collection<Temporada>(this.temporadaCollectionName).doc(temporadaId)
            .collection<Equipo>(this.equipoCollectionName, ref => ref.where("_lgBaja", "==", false).orderBy('orden', 'asc')).get();
    }

    saveEquipo(temporadaId: string, equipo: Equipo): Promise<DocumentReference<any>> {
        return this.db.collection<Temporada>(this.temporadaCollectionName).doc(temporadaId)
            .collection(this.equipoCollectionName).add(equipo);
    }

    editEquipo(temporadaId: string, equipo: EquipoViewModel): Promise<void> {
        return this.db.collection<Temporada>(this.temporadaCollectionName).doc(temporadaId)
            .collection(this.equipoCollectionName).doc(equipo.id).update(equipo);
    }

    deleteEquipo(temporadaId: string, idEquipo: string): Promise<void> {
        return this.db.collection<Temporada>(this.temporadaCollectionName).doc(temporadaId)
            .collection(this.equipoCollectionName).doc(idEquipo).delete();
    }
}
